import React, { useState } from "react";
import { Send, Wallet, ClipboardList, BarChart3 } from "lucide-react";
import { Layout } from "../../../layouts/DashboardLayout";
import TransfertsView from "./TransactionsView";
import RechargmentsView from "./RechargmentsView";
import TransactionTrackingView from "./TransactionTrackingView";
import TransactionByOperatorStatView from "./TransactionByOperatorStatView";

// Nouveau type pour le type de transaction
type TransactionType = "transfer" | "deposit" | "tracking" | "by_operator";

const TransactionsPage: React.FC = () => {
  const [transactionType, setTransactionType] = useState<TransactionType>("transfer");

  return (
    <Layout>
      <div className="mb-8">
        <h1 className="mb-2 text-3xl font-bold text-gray-800">Transactions</h1>
        <p className="text-gray-600">Suivi et gestion des transferts et rechargements</p>
      </div>

      {/* 🎯 Onglets : Transferts / Rechargements / Suivi / Stats par opérateur */}
      <div className="mb-6">
        <div className="flex gap-3 p-1 bg-gray-100 rounded-xl w-fit">
          <button
            onClick={() => setTransactionType("transfer")}
            className={`
              flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all
              ${
                transactionType === "transfer"
                  ? "bg-white text-blue-600 shadow-md"
                  : "text-gray-600 hover:text-gray-800"
              }
            `}
          >
            <Send className="w-5 h-5" />
            Transferts d'argent
          </button>
          <button
            onClick={() => setTransactionType("deposit")}
            className={`
              flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all
              ${
                transactionType === "deposit"
                  ? "bg-white text-purple-600 shadow-md"
                  : "text-gray-600 hover:text-gray-800"
              }
            `}
          >
            <Wallet className="w-5 h-5" />
            Rechargements Wallet
          </button>
          <button
            onClick={() => setTransactionType("tracking")}
            className={`
              flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all
              ${
                transactionType === "tracking"
                  ? "bg-white text-green-600 shadow-md"
                  : "text-gray-600 hover:text-gray-800"
              }
            `}
          >
            <ClipboardList className="w-5 h-5" />
            Suivi Transactions
          </button>
          <button
            onClick={() => setTransactionType("by_operator")}
            className={`
              flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all
              ${
                transactionType === "by_operator"
                  ? "bg-white text-indigo-600 shadow-md"
                  : "text-gray-600 hover:text-gray-800"
              }
            `}
          >
            <BarChart3 className="w-5 h-5" />
            Stats par Opérateur
          </button>
        </div>
      </div>

      {transactionType === "transfer" ? (
        <TransfertsView />
      ) : transactionType === "deposit" ? (
        <RechargmentsView />
      ) : transactionType === "tracking" ? (
        <TransactionTrackingView />
      ) : (
        <TransactionByOperatorStatView />
      )}
    </Layout>
  );
};

export default TransactionsPage;
